import { Component, OnInit } from '@angular/core';
import { EmpresaService } from "../service/empresa/empresa.service";
import {SecurityService} from "../service/security/security.service"
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from '../../environments/environment';
import { DocumentoService } from '../service/documento/documento.service';
import Swal from "sweetalert2";
import { Subject } from "rxjs";

declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  hide = true;
  form : FormGroup;
  loading: boolean = false;
  headers: HttpHeaders = new HttpHeaders();
  data:any;
  dataProv:any;
  dataAdq:any;
  comboProveedor:any;
  comboAdquirente:any;
  comboCliente:any;

  slideConfig2 = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '0',
    slidesToShow: 1,
    speed: 500,
    dots: true,
  };

  constructor(
    private securityService: SecurityService, private router: Router,
    private negociabesService: DocumentoService,private empresasService:EmpresaService) {
      sessionStorage.clear();
      this.form = new FormGroup({
        //Usuario: new FormControl("", [Validators.required]),   // SOLO PARA PRUEBAS
        //Password: new FormControl("", [Validators.required]),  // SOLO PARA PRUEBAS
        Usuario: new FormControl("46780390", [Validators.required]),
        Password: new FormControl("", [Validators.required]),
        Canal: new FormControl("W", [Validators.required]),
        Host: new FormControl("0", [Validators.required]),
        IP: new FormControl("0", [Validators.required]),
        NombreProyecto: new FormControl("Extranet", [Validators.required]),
        Ruc: new FormControl("0", [Validators.required]),
        //id_empresa: new FormControl("2", [Validators.required]),
        Rol: new FormControl("PROV"),
      });

      //this.ObtenerProveedoresCombo();
      //this.ObtenerAdquirentesCombo();
      //this.ObtenerClientesCombo();

    }

  ngOnInit() {
    this.proveedores.asObservable().subscribe(data => {
      this.comboProveedor = data;
    });
    this.adquirentes.asObservable().subscribe(data => {
      this.comboAdquirente = data;
    });
    this.clientes.asObservable().subscribe(data => {
      this.comboCliente = data;
    });
  }


  login() {

    this.headers = new HttpHeaders();
    this.loading = true;
      this.securityService.validarUsuario(this.form.value).subscribe(
        resp => {
          this.data = resp;
          console.log('data',this.data);
          this.encriptarTOKEN(environment.secret_key);
          sessionStorage.setItem('UserActive',JSON.stringify(resp));
          let fecha = new Date()
          sessionStorage.setItem('sessionTime',   fecha.getHours().toString() + "-"+ fecha.getMinutes());
          sessionStorage.setItem('lstProvCbo',JSON.stringify( this.comboProveedor));
          sessionStorage.setItem('lstAdqCbo',JSON.stringify( this.comboAdquirente));
          sessionStorage.setItem('lstCliCbo',JSON.stringify( this.comboCliente));
          console.log('combos',this.comboProveedor)
          console.log('combos',this.comboAdquirente)
          console.log('Rol',this.form.controls['Rol'].value)
          if(this.form.controls['Rol'].value == "PROV"){
            console.log("Acceder como proveedor");
            this.validarEmpresaProv(this.data['Ruc'])
          }else{
            this.validarEmpresaAdq(this.data['Ruc'])
          }
        },
        err => {
          console.log('this.headers', this.headers)
          console.log("err", err);
          this.loading = false;
          Swal.fire({
            icon:'error',
            title: "Error",
            text: err.error.error,
            allowOutsideClick: true,
            heightAuto: false // Resuelve bug visual
          });
        }
      );

  }
  validarEmpresaProv(ruc:string){

    this.loading = true;

    console.log('Proveedor a validar =>',ruc);
    this.negociabesService.validarEmpresaExistentePROV(ruc).subscribe(
      resp =>{
          console.log('Proveedor respuesta =>',resp);
          this.dataProv = resp;
        if(this.dataProv == undefined){
          this.negociabesService.prov = null;
          console.log('no es un proveedor')
          this.loading = false;
          Swal.fire({
            icon:'error',
            title: "Error",
            text: 'No tiene acceso de Proveedor.',
            allowOutsideClick: true,
            heightAuto: false // Resuelve bug visual
          });
        }else{
          sessionStorage.setItem('ProvActive',JSON.stringify(resp));
          this.negociabesService.prov = this.dataProv;
          this.negociabesService.adq = null;
          this.negociabesService.provSwicht = true;
          this.negociabesService.adqSwicht = false;
          console.log('si es un proveedor')
          this.router.navigate(["/dashboard"]);
          this.loading = false;
        }

      }
    )



  }

  validarEmpresaAdq(ruc:string){

    this.loading = true;
    console.log('Empresa a validar =>',ruc);
    this.negociabesService.validarEmpresaExistenteADQ(ruc).subscribe(
      respA =>{
          this.dataAdq=respA
        if(this.dataAdq == undefined){
          this.negociabesService.adq = null;
          console.log('no es un Adquirente')
          this.loading = false;
          Swal.fire({
            icon:'error',
            title: "Error",
            text: 'No tiene acceso de Adquirente.',
            allowOutsideClick: true,
            heightAuto: false // Resuelve bug visual
          });
        }else{
          sessionStorage.setItem('AdqActive',JSON.stringify(respA));
          this.negociabesService.adq = this.dataAdq;
          this.negociabesService.prov = null;
          this.negociabesService.provSwicht = false;
          this.negociabesService.adqSwicht = true;
          this.router.navigate(["/dashboard"]);
          console.log('si es un Adquirente')
          this.loading = false;
        }

      }
    )



  }

  private proveedores = new Subject<any>();
            ObtenerProveedoresCombo(){
              this.empresasService.obtenerProveedores().subscribe(res => {
              this.proveedores.next(res);
        });
      }

      private adquirentes = new Subject<any>();
            ObtenerAdquirentesCombo(){
              this.empresasService.obtenerAdquirente().subscribe(res => {
              this.adquirentes.next(res);
        });
      }

      private clientes = new Subject<any>();
            ObtenerClientesCombo(){
              this.empresasService.obtenerEmpresa().subscribe(res => {
              this.clientes.next(res);
        });
      }

  encriptarTOKEN(palabra: string) {

    const par= "U8WITLR2EMQVdI0bqQRjkKZaTrxxYq";
    const impar="LyJDZGaw9Iwl7Sr1ZK4J";

    let p1 = `${par}ñ${impar}ñ${par}ñ${impar}ñ${palabra}ñ${impar}ñ${par}ñ${impar}ñ${par}ñ${impar}ñ${par}ñ${impar}ñ${palabra}ñ${impar}ñ${par}ñ${impar}ñ${par}`;

    sessionStorage.setItem('Kn48Nki8is9dhan54648asm78f6s3JDF56L4Ndf2SDdas55', p1.trim());


  }

  showNotification(type,from,align,message){
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
